import { render, staticRenderFns } from "./CalendarChips.vue?vue&type=template&id=8670458e&scoped=true"
import script from "./CalendarChips.vue?vue&type=script&lang=js"
export * from "./CalendarChips.vue?vue&type=script&lang=js"
import style0 from "./CalendarChips.vue?vue&type=style&index=0&id=8670458e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8670458e",
  null
  
)

export default component.exports